import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const {
    resultsAreLoaded,
    totalItems,
    noResultsInfo,
    searchListingsError,
    isValidDatesFilter,
    resetAll,
    location,
  } = props;

  if (searchListingsError) {
    return (
      <div className={css.errorContainer}>
        <p className={css.error}>
          <FormattedMessage id="SearchPage.searchError" />
        </p>
      </div>
    );
  }

  if (!isValidDatesFilter) {
    return (
      <div className={css.errorContainer}>
        <p className={css.error}>
          <FormattedMessage id="SearchPage.invalidDatesFilter" />
        </p>
      </div>
    );
  }

  const hasNoResult = resultsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  if (hasNoResult) {
    return (
      <div className={css.noSearchResults}>
        {noResultsInfo ? (
          noResultsInfo
        ) : (
          <p className={css.noSearchResultsText}>
            <FormattedMessage id="SearchPage.noResults" />
          </p>
        )}
        {hasSearchParams && (
          <button className={css.resetAllFiltersButton} onClick={resetAll}>
            <FormattedMessage id="SearchPage.resetAllFilters" />
          </button>
        )}
      </div>
    );
  }

  return null;
};

export default NoSearchResultsMaybe;
